export const extractFirstLetter = (str) => {
  if (str) {
    return str.charAt(0).toUpperCase()
  }
  return str
}
